import React from 'react';

// Shared SVG data-viz primitives — theme-aware (CSS vars work in SVG via `style`,
// not attributes). Used by the Home dashboard and Analytics so both pages share
// one visual language. No chart-library dependency.

// Circular single-arc progress ring (the "path to victory" hero).
export function ProgressRing({ pct, size = 176, stroke = 14, color = '#3b82f6', children }) {
  const r = (size - stroke) / 2;
  const C = 2 * Math.PI * r;
  const p = Math.min(Math.max(pct, 0), 100);
  const dash = (p / 100) * C;
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} style={{ stroke: 'var(--surface-2)' }} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} strokeLinecap="round"
          style={{ stroke: color, strokeDasharray: `${dash} ${C - dash}`, transition: 'stroke-dasharray 0.9s cubic-bezier(0.4,0,0.2,1)' }} />
      </svg>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        {children}
      </div>
    </div>
  );
}

// Multi-segment donut — distribution viz.
export function SegmentDonut({ segments, size = 156, stroke = 20 }) {
  const r = (size - stroke) / 2;
  const C = 2 * Math.PI * r;
  const total = segments.reduce((s, x) => s + x.value, 0) || 1;
  let offset = 0;
  return (
    <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke} style={{ stroke: 'var(--surface-2)' }} />
      {segments.map((s, i) => {
        const dash = (s.value / total) * C;
        const node = (
          <circle key={i} cx={size / 2} cy={size / 2} r={r} fill="none" strokeWidth={stroke}
            style={{ stroke: s.color, strokeDasharray: `${dash} ${C - dash}`, strokeDashoffset: -offset, transition: 'stroke-dasharray 0.6s ease' }} />
        );
        offset += dash;
        return node;
      })}
    </svg>
  );
}
